<div class="box-layout box-layout-child"
     *ngIf="!isLoading; else loadingTemplate">
  <h2>
    <pop-chevron [(isExpanded)]="showCustomLabels">
      <span class="h2"
            translate="OPTIONS.LABELS"></span>
    </pop-chevron>
  </h2>
  <ng-container *ngIf="showCustomLabels">
    <pop-settings-box labelKey="OPTIONS.DEP_FR">
      <input class="settings-field settings-input-padding"
             id="depFR"
             type="text"
             (change)="changed()"
             [(ngModel)]="estimateConfig.departmentLabelFR"
             name="depFR"
             maxlength="30" />
      <div aside
           class="description"
           translate="OPTIONS.LABELS_DESC">
      </div>
    </pop-settings-box>

    <pop-settings-box labelKey="OPTIONS.DEP_EN">
      <input class="settings-field settings-input-padding"
             id="depEN"
             type="text"
             (change)="changed()"
             [(ngModel)]="estimateConfig.departmentLabelEN"
             name="depEN"
             maxlength="30" />
      <div aside
           class="description">
      </div>
    </pop-settings-box>
  </ng-container>

  <h2 class="new-section">
    <pop-chevron [(isExpanded)]="showEstimateTable">
      <span class="h2"
            translate="OPTIONS.ESTIMATE_TABLE"></span>
    </pop-chevron>
  </h2>
  <ng-container *ngIf="showEstimateTable">
    <h3 translate="OPTIONS.SECTIONS"></h3>

    <pop-settings-box labelKey="OPTIONS.DATES">
      <pop-switch middle
                  [reversed]="true"
                  [(isSwitched)]="estimateConfig.hideSectionDates"
                  (isSwitchedChange)="changed()"></pop-switch>
      <div aside
           class="description"
           translate="OPTIONS.ESTIMATE_TABLE_SECTION_DESC"></div>
    </pop-settings-box>

    <pop-settings-box labelKey="OPTIONS.NOTES">
      <pop-switch middle
                  [reversed]="true"
                  [(isSwitched)]="estimateConfig.hideSectionNotes"
                  (isSwitchedChange)="changed()"></pop-switch>
      <div aside
           class="description"></div>
    </pop-settings-box>

    <pop-settings-box labelKey="OPTIONS.FEES">
      <pop-switch middle
                  [reversed]="true"
                  [(isSwitched)]="estimateConfig.hideSectionFees"
                  (isSwitchedChange)="changed()"></pop-switch>
      <div aside
           class="description"></div>
    </pop-settings-box>

    <pop-settings-box *ngIf="estimateConfig?.activateInternalFees"
                      labelKey="OPTIONS.INTERNAL_FEES">
      <pop-switch middle
                  [reversed]="true"
                  [(isSwitched)]="estimateConfig.hideSectionInternalFees"
                  (isSwitchedChange)="changed()"></pop-switch>
      <div aside
           class="description"></div>
    </pop-settings-box>

    <pop-settings-box labelKey="OPTIONS.EXPENSES">
      <pop-switch middle
                  [reversed]="true"
                  [(isSwitched)]="estimateConfig.hideSectionExpenses"
                  (isSwitchedChange)="changed()"></pop-switch>
      <div aside
           class="description"></div>
    </pop-settings-box>

    <pop-settings-box labelKey="OPTIONS.BUDGET_PERCENTAGE">
      <pop-switch middle
                  [reversed]="true"
                  [(isSwitched)]="estimateConfig.hideSectionBudgetPercentage"
                  (isSwitchedChange)="changed()"></pop-switch>
      <div aside
           class="description"></div>
    </pop-settings-box>
  </ng-container>

  <h2 class="new-section">
    <pop-chevron [(isExpanded)]="showBudgetPercentColumns">
      <span class="h2"
            translate="OPTIONS.BUDGET_PERCENT_COLUMNS"></span>
    </pop-chevron>
  </h2>
  <ng-container *ngIf="showBudgetPercentColumns">
    <h3 translate="OPTIONS.BUDGET_PERCENT_DISPLAY"></h3>

    <pop-settings-box labelKey="OPTIONS.BUDGET_PERCENT_LEVEL1">
      <pop-switch middle
                  [reversed]="true"
                  [(isSwitched)]="estimateConfig.hideBudgetPercentLevel1"
                  (isSwitchedChange)="changed()"></pop-switch>
      <div aside
           class="description"
           translate="OPTIONS.BUDGET_PERCENT_DISPLAY_DESC"></div>
    </pop-settings-box>

    <pop-settings-box labelKey="OPTIONS.BUDGET_PERCENT_LEVEL2">
      <pop-switch middle
                  [reversed]="true"
                  [(isSwitched)]="estimateConfig.hideBudgetPercentLevel2"
                  (isSwitchedChange)="changed()"></pop-switch>
      <div aside
           class="description"></div>
    </pop-settings-box>

    <pop-settings-box labelKey="OPTIONS.BUDGET_PERCENT_DEPT">
      <pop-switch middle
                  [reversed]="true"
                  [(isSwitched)]="estimateConfig.hideBudgetPercentDepartment"
                  (isSwitchedChange)="changed()"></pop-switch>
      <div aside
           class="description"></div>
    </pop-settings-box>

    <pop-settings-box labelKey="OPTIONS.BUDGET_PERCENT_CAT">
      <pop-switch middle
                  [reversed]="true"
                  [(isSwitched)]="estimateConfig.hideBudgetPercentCategory"
                  (isSwitchedChange)="changed()"></pop-switch>
      <div aside
           class="description"></div>
    </pop-settings-box>
  </ng-container>

  <ng-container *ngIf="showBudgetPercentColumns">
    <h3 translate="OPTIONS.BUDGET_PERCENT_CALCULATION"></h3>

    <pop-settings-box labelKey="OPTIONS.BUDGET_PERCENT_DENOMINATOR">
      <pop-radio-button-group [options]="budgetPercentDenominatorValues"
                              (click)="changed()"
                              [(selectedOption)]="estimateConfig.budgetPercentDenominator">
      </pop-radio-button-group>
      <div aside
           class="description"
           translate="OPTIONS.BUDGET_PERCENT_DENOMINATOR_DESC"></div>
    </pop-settings-box>

  </ng-container>
</div>

<ng-template #loadingTemplate>
  <pop-loading [isInline]="true"></pop-loading>
</ng-template>
